/*
 Created by CHT 2019/9/17 16:58
 */
import BaseItem from "../BaseItem"
import {
  DATA_TYPE__NUMBER,
  DEFAULT_VALUE__CUSTOM,
  DEFAULT_VALUE__FORMULA,
  DEFAULT_VALUE__RELATE_DATA,
  FORM_ITEM__NUMBER, FORM_ITEM__TABLE
} from '../types'
import {defaultValueInit} from "../utils"
import {formatNum, isString} from "../../../assets/js/Untis";
import {formatNumber} from "vant/lib/utils/format/number";

class Digital extends BaseItem {

  constructor() {
    super()

    this.checkCondition = {
      checkType: 'NUMBER',
      integerOnly: 0,   // 只允许整数 0 否 1 是
      numLimit: 0,      // 开启大小限制 0 否 1 是
      minNum: 0,        // 最小值
      maxNum: 10000,    // 最大值
      decimalLimit: 0,  // 小数点后位数限制 0 否 1 是
      decimalCount: 2   // 小数点后几位
    }

    this.tp = 'NO' // 开启千分符
    this.showUnit = '' // 单位
    // 值
    this.value = null
    this.defaultValue = {
      defaultType: ''
    }
  }

  get title() {
    return this.fieldTitle || Digital._title
  }

   set title(val) {
    this.fieldTitle = val
		this.temTitle = val
  }
}

Digital._title = '数字'
Digital.type = FORM_ITEM__NUMBER
Digital.use = true
Digital.icon = 'iconfont icon-shuzi'

Digital.prototype.type = Digital.type
Digital.prototype.dataType = DATA_TYPE__NUMBER
Digital.prototype.defaultValueList = [
  {
    label: '不设置',
    value: {
      defaultType: ''
    }
  },
  {
    label: "自定义",
    value: defaultValueInit(DEFAULT_VALUE__CUSTOM, 0)
  },
  {
    label: '公式',
    value: defaultValueInit(DEFAULT_VALUE__FORMULA)
  },
  {
    label: '关联数据',
    value: defaultValueInit(DEFAULT_VALUE__RELATE_DATA)
  }
]
Digital.prototype.filterOpts = [
  {
    name: '等于',
    method: 'eq'
  },
  {
    name: '不等于',
    method: 'ne'
  },
  {
    name: '大于',
    method: 'gt'
  },
  {
    name: '大于等于',
    method: 'gte'
  },
  {
    name: '小于',
    method: 'lt'
  },
  {
    name: '小于等于',
    method: 'lte'
  },
  {
    name: '选择范围',
    method: 'range'
  },
  {
    name: '为空',
    method: 'empty'
  },
  {
    name: '不为空',
    method: 'not_empty'
  },
]
Digital.prototype.getValue = function () {
  if (isString(this.value)) {
    return this.value ? Number(this.value) : null
  } else {
    return this.value
  }
}
Digital.prototype.setValue = function (val) {
  if (this.parent && this.parent.type === FORM_ITEM__TABLE) {
    return
  }
  if (this.checkCondition.numLimit) {
    if (val < this.checkCondition.minNum) {
      return
    } else if (val > this.checkCondition.maxNum) {
      return
    }
  }

  if (this.checkCondition.integerOnly) {
    // 只能是整数 val && Number.isInteger(val)
    if (val && !Number.isInteger(val)) {
      val = Math.round(parseFloat(val) * Math.pow(10, 0)) / Math.pow(10, 0)
    }
  } else {
    // 可以有小数
    if (this.checkCondition.decimalLimit) {
      // 开启小数位数验证
      if (val.toString().split(".")[1] &&
        val.toString().split(".")[1].length > this.checkCondition.decimalCount) {
        val = Math.round(parseFloat(val) * Math.pow(10, this.checkCondition.decimalCount)) / Math.pow(10, this.checkCondition.decimalCount)
      }
    }
  }
  this.value = val ? Number(val) : val
}
Digital.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    checkCondition: this.checkCondition,
    defaultValue: this.defaultValue,
    showUnit: this.showUnit,
    tp: this.tp
  }
}
Digital.prototype.setConf = function (opts) {
  this.setBase(opts)
  this.showUnit = opts.showUnit ? opts.showUnit : ''
  if (opts.checkCondition) {
    this.checkCondition = opts.checkCondition
  }
  this.tp = opts.tp || 'NO'
  if (opts.defaultValue) {
    this.defaultValue = opts.defaultValue
    if (opts.defaultValue.defaultType === DEFAULT_VALUE__CUSTOM) {
      this.value = this.defaultValue.customValue
    }
  }
}
Digital.prototype.valueToString = function (value) {
  if (Object.prototype.toString.call(value) === '[object Null]' ||
    Object.prototype.toString.call(value) === '[object Undefined]') {
    value = this.value
  }
  if (this.tp === 'YES') {
    value = formatNum(value)
  }
  return `${value}${this.showUnit}`
}
export default Digital
